<template>
  <div class="relative">
    <b-table
      :items="fetcher.data"
      :fields="fields"
      class="mt-1 !max-h-[70vh] !mb-0"
      :empty-text="fetcher.isLoading ? '' : 'Tidak ada data yang ditampilkan.'"
      responsive
      sticky-header
      show-empty
      @scroll.native="handleScroll"
    >
      <template #cell(status)="row">
        <div>
          <span
            class="rounded-full py-[4px] px-[12px] border-solid border-[1px] inline-block text-[12px] font-medium"
            :class="parseStatus(row.value).css"
          >
            {{ parseStatus(row.value).label }}
          </span>
        </div>
      </template>
      <template #cell(id)="row">
        <b-button
          variant="outline-primary"
          size="sm"
          class="text-[#08A0F7]"
          @click="handleOpenDetail(row.item)"
        >
          Lihat Detail
        </b-button>
      </template>
    </b-table>
    <div
      v-if="fetcher.isLoading"
      class="absolute bottom-0 left-0 right-0 flex justify-center items-center p-[20px] bg-white bg-opacity-90"
    >
      <div class="flex items-center gap-2">
        <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600" />
        <span class="text-sm text-gray-600">Memuat data...</span>
      </div>
    </div>

    <ModalDetailPengajuanMitra
      ref="mdpm_kompack"
      @success="handleSuccess"
    />
  </div>
</template>

<script>
import { createPaginatedFetcher } from '@/@core/libs/fetch/usePaginatedFetcher'
import { pengajuanMitraFields, mitraPengajuanStatus, PENGAJUAN_MITRA_LIMIT } from '../config'
import ModalDetailPengajuanMitra from './ModalDetailPengajuanMitra.vue'

export default {
  components: {
    ModalDetailPengajuanMitra,
  },
  data() {
    return {
      fetcher: null,
    }
  },
  computed: {
    fields() {
      return pengajuanMitraFields
    },
  },
  created() {
    this.initializeFetcher()
  },
  mounted() {
    this.fetcher.fetchData({ reset: true })
  },
  methods: {
    initializeFetcher() {
      const fnFetch = ({ offset, limit, ...options }) => this.$http_new.get('/komship/api/v1/admin/kompack/mitra/submission', {
        params: {
          offset,
          limit,
          ...options,
        },
      }).then(res => {
        const { data } = res.data
        return {
          data,
        }
      }).catch(() => {
        this.$toast_error({ message: 'Gagal mengambil data pengajuan mitra, silahkan coba lagi' })
        return {
          data: [],
        }
      })
      this.fetcher = createPaginatedFetcher(fnFetch, 0, PENGAJUAN_MITRA_LIMIT)
    },
    /**
     * @description Parse status to label and css.
     * @param status {number} - Status of the pengajuan mitra
     * @returns {Object} - Object containing label and css
     */
    parseStatus(status) {
      const parsedStatus = mitraPengajuanStatus[status]
      if (!parsedStatus) {
        return {
          label: '-',
          css: '',
        }
      }
      return parsedStatus
    },
    /**
     * @description Open detail modal
     * @param item {Object} - Item data that will be passed to the modal
     */
    handleOpenDetail(item) {
      this.$refs.mdpm_kompack.show({ item })
    },
    /**
     * @description Handle scroll for infinite loading.
     * @param {Event} event - Event scroll
     */
    handleScroll(event) {
      if (event.target.scrollTop + event.target.clientHeight + 500 >= event.target.scrollHeight) {
        if (this.fetcher.data.length <= 0) return
        this.fetcher.fetchData()
      }
    },
    /**
     * @description Handle when rejection/approval action is successful.
     * This will trigger the fetcher to fetch data again so the table will be updated.
     */
    handleSuccess() {
      this.fetcher.fetchData({ reset: true })
    },
  },
}
</script>
